import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

@Component({
  selector: 'app-text-input',
  templateUrl: './text-input.component.html',
})
export class TextInputComponent {
  @Input() control!: AbstractControl;
  @Input() label = '';
  @Input() required = false;
  @Input() optional = false;
  @Input() submitted = false;
  @Input() errorMessages: { [key: string]: string } = {};
  @Input() serverError: string | null | undefined = '';
  @Input() type = 'text';
  @Input() id = '';
  @Input() placeholder = '';
  @Input() maxlength: number | null = null;
  @Input() minlength: number | null = null;
  @Input() autocomplete = 'off';
  @Input() readonly = false;
  @Input() pattern: string | null = null;

  @Output() keypress = new EventEmitter<KeyboardEvent>();
  @Output() input = new EventEmitter<Event>();
  @Output() paste = new EventEmitter<ClipboardEvent>();
  @Output() focus = new EventEmitter<FocusEvent>();
  @Output() focusout = new EventEmitter<FocusEvent>();

  get formControl(): FormControl {
    return this.control as FormControl;
  }

  get isInvalid(): boolean {
    return !!(this.submitted && this.control && this.control.invalid);
  }
}
